import React from 'react';
import './ActivityLegend.css';

const ActivityLegend = React.memo(() => {
  return (
    <div className="activity-legend">
      <h3>Activity Score</h3>
      <div className="legend-item">
        <span className="legend-color high"></span>
        <span>High (80-100)</span>
      </div>
      <div className="legend-item">
        <span className="legend-color medium"></span>
        <span>Medium (50-79)</span>
      </div>
      <div className="legend-item">
        <span className="legend-color low"></span>
        <span>Low (0-49)</span>
      </div>
      <div className="legend-item">
        <span className="legend-color pending"></span>
        <span>Not Registered</span>
      </div>
    </div>
  );
});

ActivityLegend.displayName = 'ActivityLegend';

export default ActivityLegend;

